import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/priceService";
const store = {};
const mutations = {
    SET_PRICE_LIST(state, posts) {
        state.priceList = posts;
        state.priceListIsLoading = false;
    },
    SET_PRICE_LIST_SIMPLE(state, posts) {
        state.priceListSimple = posts;
    },
    GET_PRICE_DETAIL(state, posts) {
        state.priceDetail = posts.data;
        state.priceDetailIsLoading = false;
    },  
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.priceDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    priceList: [],
    priceListIsLoading: false,
    priceListSimple: [],
    priceDetailIsLoading: false,
    priceDetailChanged: false,
    priceDetail: {}, 
};
const getters = {};
const actions = {
    getPriceListSimple({ commit }) { 
        axios
            .get(baseUri + '/GetListSimple')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_PRICE_LIST_SIMPLE', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getPriceList({ commit }) {
        state.priceListIsLoading = true;
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_PRICE_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getPriceDetail({ commit }, data) {
        state.priceDetailIsLoading = true;
        state.fieldAccessIsLoading = true;
        axios
            .get(baseUri + '/GetDetail?PriId=' + data.priId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_PRICE_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },  
    savePriceDetail({ commit }) {
        var formData  = new FormData();
        formData.append("data", JSON.stringify(state.priceDetail));
        axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating your record: " + res.data.errorMessage);
                }
            });
    },  
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}